import React, { Component } from "react";
export default class Base extends Component {

  setState = (objOrFunc, callback) => new Promise((resolve, reject) => {
    if(this._mounted === false) return resolve();
    super.setState(objOrFunc, () => {
      if(typeof callback === "function") {
        callback();
      } else {
        resolve();
      }
    })
  });

  componentDidMount() {
    this._mounted = true;
    typeof this.didMount === "function" && this.didMount();
  }

  componentWillUnmount() {
    this._mounted = false;
    typeof this.willUnmount === "function" && this.willUnmount();
  }
}


// WEBPACK FOOTER //
// ./src/custom/Base.js